import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const PHONE_DISPLAY = "610 93 55 31";
export const WA_NUMBER = "34610935531";
export const BRAND = "Inmobiliaria Tecnohogar";
export const TAGLINE = "Tu hogar, nuestro compromiso";

export const waLink = (text) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
export const waDefault = () => waLink("Hola Inmobiliaria Tecnohogar, tengo una consulta.");

export const api = axios.create({ baseURL: API, withCredentials: true });

export const imgSrc = (p) => {
  if (!p) return "";
  if (p.startsWith("http")) return p;
  if (p.startsWith("/api/")) return `${BACKEND}${p}`;
  return `${BACKEND}/api/files/${p}`;
};

export const eur = (n) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

export const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleString("es-ES", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const formatError = (detail) => {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
